import { createSlice } from "@reduxjs/toolkit";
import { fetchInStockViewDetails } from "./thunk";


interface FetchInStockState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FetchInStockState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DailyLogViewDetailsSlice = createSlice({
  name: "In stock view details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInStockViewDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInStockViewDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInStockViewDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch In Stock item List";
      });
  },
});

export default DailyLogViewDetailsSlice.reducer;
